import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ProIndex from './proindex';
import reportWebVitals from './reportWebVitals';
import { inject } from '@vercel/analytics';
 
inject();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProIndex />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
